module.exports = __webpack_public_path__ + "static/media/install02.2a0928b2.png";